var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-2 pr-2 pt-2 pb-1 mb-1"},[_c('strong',[_vm._v(_vm._s(_vm.field.display_name))]),_c('hr'),_c('parameter-viewer',{key:'group' + _vm.field.name,attrs:{"fields":_vm.field.fields,"value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }